var map = {
	"./account.svg": "h+4i",
	"./arrow-down-thin.svg": "qExC",
	"./arrow-down.svg": "jIbX",
	"./arrow-left.svg": "51GQ",
	"./arrow-right.svg": "Qsna",
	"./arrow-up.svg": "Omm2",
	"./basket.svg": "iwUV",
	"./beaker.svg": "wMjV",
	"./calendar.svg": "Rrki",
	"./delete-logo.svg": "3yJq",
	"./doc-default.svg": "wVxo",
	"./doc-doc.svg": "q+S6",
	"./doc-pdf.svg": "M3U0",
	"./doc-ppt.svg": "Gt49",
	"./document.svg": "LUPE",
	"./download.svg": "5mra",
	"./header-angle.svg": "noH7",
	"./just-giving-logo.svg": "f2JW",
	"./letter.svg": "BFzH",
	"./modal_close.svg": "GKKS",
	"./pencil.svg": "wt25",
	"./person.svg": "DBgD",
	"./phone.svg": "c1Qd",
	"./search.svg": "98Kd",
	"./share.svg": "gPpe",
	"./slant-gradient.svg": "JqIc",
	"./sms.svg": "DPol",
	"./tick.svg": "ddC+",
	"./tick2.svg": "1Di1",
	"./user.svg": "OBau",
	"./user2.svg": "+Xj0",
	"./web.svg": "lKHb"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vz3G";


//////////////////
// WEBPACK FOOTER
// ./app/general/svg ^\.\/.*\.svg
// module id = vz3G
// module chunks = 0